/**
 * Interest → engagement value-band catalog for elmbsol.com contact form.
 * Keep in sync with api/lib/interestValueCatalog.js (server validates amounts).
 */

export const INTEREST_VALUE_CATALOG = {
  'Technology Strategy Review': [
    {
      id: 'tsr-exploratory',
      label: 'Exploratory',
      amountUsd: 2500,
      icpBump: 5
    },
    {
      id: 'tsr-standard',
      label: 'Standard',
      amountUsd: 5000,
      icpBump: 10
    },
    {
      id: 'tsr-extended',
      label: 'Extended',
      amountUsd: 10000,
      icpBump: 15
    }
  ],
  'Technology Assessment & Roadmap': [
    {
      id: 'tar-scoped',
      label: 'Scoped',
      amountUsd: 15000,
      icpBump: 10
    },
    {
      id: 'tar-full',
      label: 'Full',
      amountUsd: 25000,
      icpBump: 15
    },
    {
      id: 'tar-enterprise',
      label: 'Enterprise',
      amountUsd: 40000,
      icpBump: 20
    }
  ],
  'vCIO Advisory': [
    {
      id: 'vcio-025',
      label: 'Fractional 0.25',
      amountUsd: 3000,
      icpBump: 15
    },
    {
      id: 'vcio-05',
      label: 'Fractional 0.5',
      amountUsd: 6000,
      icpBump: 20
    },
    {
      id: 'vcio-full',
      label: 'Full',
      amountUsd: 12000,
      icpBump: 25
    }
  ],
  'Twenty CRM Implementation': [
    {
      id: 'crm-starter',
      label: 'Starter',
      amountUsd: 15000,
      icpBump: 10
    },
    {
      id: 'crm-standard',
      label: 'Standard',
      amountUsd: 30000,
      icpBump: 15
    },
    {
      id: 'crm-complex',
      label: 'Complex',
      amountUsd: 50000,
      icpBump: 20
    }
  ],
  'AI Automation': [
    {
      id: 'ai-pilot',
      label: 'Pilot workflow',
      amountUsd: 7500,
      icpBump: 10
    },
    {
      id: 'ai-standard',
      label: 'Standard build',
      amountUsd: 15000,
      icpBump: 15
    },
    {
      id: 'ai-program',
      label: 'Multi-flow program',
      amountUsd: 30000,
      icpBump: 20
    }
  ],
  'RingCentral Communications': [
    {
      id: 'rc-info',
      label: 'Information / demo',
      amountUsd: 0,
      icpBump: 5
    },
    {
      id: 'rc-pilot',
      label: 'Pilot (under 25 users)',
      amountUsd: 5000,
      icpBump: 10
    },
    {
      id: 'rc-org',
      label: 'Organization rollout',
      amountUsd: 15000,
      icpBump: 15
    }
  ],
  'Not sure yet': [
    {
      id: 'unsure-unknown',
      label: 'Unknown',
      amountUsd: 0,
      icpBump: 0
    },
    {
      id: 'unsure-exploring',
      label: 'Exploring',
      amountUsd: 5000,
      icpBump: 5
    }
  ]
};

export const INTEREST_OPTIONS = Object.keys(INTEREST_VALUE_CATALOG);

export function getValueBandsForInterest(interest) {
  return INTEREST_VALUE_CATALOG[String(interest || '').trim()] || [];
}

export function resolveValueBand(interest, valueBandId) {
  const bands = getValueBandsForInterest(interest);
  const id = String(valueBandId || '').trim();
  if (!id) {
    return null;
  }
  return bands.find((band) => band.id === id) || null;
}
